import React from 'react';
import './Spacer.css';

export const Spacer: React.FC = () => {
	return <div className='da-spacer' />
}